import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Validators } from '@angular/forms';
import { AbEnderecoIntegrador } from 'app/abstract/full-pages/integrador/endereco-integrador.abstract';


@Injectable({ providedIn: 'root' })
export class EnderecoIntegradorService extends AbEnderecoIntegrador {

  constructor(http: HttpClient) {
    super(http);
  }

  public getEnderecoCompleto(cep: number): Observable<any> {
    return this.get(`admin/enderecos/cep/${cep}`);
  }

  salvarEndereco(id: number, endereco: any): Observable<any> {
    return this.http.put(`${this.url}admin/integradores/${id}/endereco`, endereco);
  }
  getEndereco(id: number): Observable<any> {
    return this.http.get(`${this.url}admin/integradores/${id}/endereco`);
  }
  public obrigatoriedadeCampo(obrigatorio, campo): Boolean {
    if (obrigatorio) {
      campo.setValidators(Validators.compose([Validators.required]));
      campo.updateValueAndValidity({ onlySelf: true });
      return;
    }

    campo.setValidators(null);
    campo.updateValueAndValidity({ onlySelf: false });
  }

}
